import { TrackingHelper, ArticleTrackingData, PiwikArticleTrackingData } from '@escid-espp1/helpers';
import { IBasketModalDataForLogoCreator, IBasketModalData } from '../../types/properties';

interface ITrackingOptions {
    disableDirectEcommerceTracking: boolean; enableKraken: boolean;
}

export function trackAddToCart(data: IBasketModalData, trackingHelper: TrackingHelper, options: ITrackingOptions) {
    const price = {
        grossValue: Number(data.grossPrice),
        netValue: Number(data.netPrice),
    }
    const scaledPrices = data.scalePrice ? [{
        grossValue: Number(data.scalePrice.grossValue),
        netValue: Number(data.scalePrice.netValue),
    }] : null;

    const trackingData: PiwikArticleTrackingData = {
        id: data.flexSetId || data.salesVariantKey,
        name: data.title,
        price: price,
        scaledPrices: scaledPrices,
        brand: data.isStraussBrand ? 'Strauss' : 'other Brand',
        category: data.nativeNavKeyPath,
        currencyCode: data.currencyISO,
        variantId: data.basketItemId || data.salesVariantKey,
        colorCode: data.color,
        colorName: data.colorName,
        sizeName: data.size,
        modelCode: data.model,
        modelName: data.modelLabel,
        masterArticleNo: data.masterArticleNo,
        productRecommendationFragment: data.productRecommendationFragment,
        productRecommendationModel: data.productRecommendationModel,
        productRecommendationTileIndex: data.productRecommendationTileIndex,
    };

    trackingHelper.setItemOrigin(data.itemOrigin);

    if (!options.disableDirectEcommerceTracking) {
        const piwikTrackingData = { ...trackingData };
        piwikTrackingData.id = data.flexSetId || data.salesArticleNo;

        trackingHelper.piwikTrackAddToCart(piwikTrackingData, data.quantity);
        trackingHelper.metaTrackAddToCart(trackingData, data.quantity);
        trackingHelper.tiktokTrackAddToCart(trackingData, data.quantity);
    }

    if (options.enableKraken) {
        trackingData.id = data.flexSetId || data.salesArticleNo;
        trackingHelper.krakenTrackAddToCart(trackingData, data.quantity, 'ESPP3.BasketModal');
    }
}

export function trackAddToCartFromLC(data: IBasketModalDataForLogoCreator, trackingHelper: TrackingHelper, options: ITrackingOptions) {
    let totalGrossValue = 0;
    let totalNetValue = 0;
    let totalQuantity = 0;

    const contents = data.sizesWithPrice.map(size => {
        return { id: size.savKey, quantity: size.quantity };
    });
    
    if (Array.isArray(contents) && contents.length > 0) {
        trackingHelper.setItemOrigin(data.itemOrigin);

        const trackingData: ArticleTrackingData = {
            id: contents[0].id?.split('-')[0],
            name: data.title,
            brand: data.isStraussBrand ? 'Strauss' : 'other Brand',
            category: data.nativeNavKeyPath,
            price: { grossValue: totalGrossValue, netValue: totalNetValue },
            currencyCode: data.reporting.price.currency,
            variantId: contents[0].id,
            contents,
        }


        if (!options.disableDirectEcommerceTracking || options.enableKraken) {
            data.sizesWithPrice.forEach(size => {
                const keys = size.savKey.split('-');
                const price = { netValue: size.netPrice, grossValue: size.grossPrice };

                totalGrossValue += size.grossPrice * size.quantity;
                totalNetValue += size.netPrice * size.quantity;
                totalQuantity += size.quantity;

                const reportingPrice = data.reporting.price.value * size.quantity

                const trackingData: ArticleTrackingData = {
                    id: keys[0],
                    name: data.title,
                    price: price,
                    brand: data.isStraussBrand ? 'Strauss' : 'other Brand',
                    category: data.nativeNavKeyPath,
                    currencyCode: data.reporting.price.currency,
                    variantId: size.savKey,
                    colorCode: data.color,
                    colorName: data.colorName,
                    sizeCode: Array.isArray(data.size) ? data.size[0] : data.size,
                    sizeName: size.label,
                    modelCode: data.model,
                    modelName: data.modelLabel,
                    masterArticleNo: String(data.masterArticleNumber),
                    customizations: data.reporting.customizations,
                    reportingPrice,
                };

                if (!options.disableDirectEcommerceTracking) {
                    trackingHelper.piwikTrackAddToCart(trackingData, size.quantity);
                }

                if (options.enableKraken) {
                    trackingHelper.krakenTrackAddToCart(trackingData, size.quantity, 'ESPP3.BasketModal');
                }
            });

            trackingData.reportingPrice = data.reporting.price.value * totalQuantity; 
            trackingData.price = { netValue: totalNetValue, grossValue: totalGrossValue };
            if (!options.disableDirectEcommerceTracking) {
                trackingHelper.metaTrackAddToCart(trackingData, totalQuantity);
                trackingHelper.tiktokTrackAddToCart(trackingData, totalQuantity);
            }
        }
    }
}